import React, { useEffect, useState } from 'react'
import PrimaryButton from 'src/components/shared/PrimaryButton'
import RichText from '../../../../shared/RichText'
import styles from './index.module.scss'
import { generateElementId } from '../../../../../common/helpers'
import classNames from 'classnames'

const KindOfDebt = ({ data }) => {
  const [isSmallHeightDevice, setIsSmallHeightDevice] = useState(false)
  useEffect(() => {
    if (window.innerHeight < 750) {
      setIsSmallHeightDevice(true)
    }
  }, [])

  return (
    <>
      <h3
        className="mb-5 px-5 text-lg font-bold"
        id={generateElementId(data.headLine)}
      >
        {data.headLine}
      </h3>
      <div
        data-testid="wrapper"
        className={classNames(
          'overflow-scroll px-5',
          { 'h-75': isSmallHeightDevice },
          { 'h-100': !isSmallHeightDevice }
        )}
      >
        <RichText contentData={data.info} className={styles.info} />
        <div className="mb-8">
          {data.debts.map((debt, index) => (
            <div key={index}>
              <p className="text-xs font-bold">{debt.title}</p>
              <ul key={index} className="mb-8 text-xs leading-5">
                {debt.debtTypes.map((type, index) => (
                  <li key={index}>{type}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <p className="mb-2 pb-4 text-xs leading-5">{data.contact}</p>
      </div>
      <div className="border-t pt-4">
        <div
          className="m-4 flex items-center justify-center rounded-lg border-t-2 bg-blue-base py-3 text-white"
          id="call-number"
        >
          <PrimaryButton
            sectionTitle={data.headLine}
            href="tel:800-910-0065"
            title="Call 800-910-0065"
          />
        </div>
      </div>
    </>
  )
}

export default KindOfDebt
